import {
  Component,
  OnInit,
  OnDestroy,
  signal,
  inject,
  computed,
  WritableSignal,
  effect,
  ChangeDetectionStrategy,
} from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { ListingItem } from 'depoto-core/src/models'
import { CoreService, NotificationService } from '../../services'
import { SchemaUtil } from '../../utils'
import { TranslateService } from '@ngx-translate/core'
import { checkoutsColumns, printOrderExportsColumns } from '../../utils/definitions.util'
import { OrderExportService } from '../../services/entity-services/orderExport.service'
import { injectInfiniteQuery } from '@tanstack/angular-query-experimental'

const DEFAULT_FILTERS = {
  // sortProp: 'created',
  // sortDir: 'desc',
}

@Component({
  selector: 'app-print-order-exports',
  templateUrl: 'print-order-exports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrintOrderExportsComponent extends BaseListing implements OnInit, OnDestroy {
  private orderExportService = inject(OrderExportService)

  listingColumns = signal(printOrderExportsColumns)
  reports: any[] = []
  totalItems = computed(() => {
    console.error(this.queryOrderExports.data())
    return 100
  })
  currentPage: number
  endPage: number
  // filters = { ...DEFAULT_FILTERS }
  refreshInterval: any = null
  loading = true
  // storageKey: WritableSignal<{ type: string; key: string }> = signal({ type: '', key: '' })
  sortProp = signal('created')
  sortDir = signal('desc')

  readonly queryOrderExports = injectInfiniteQuery(() => ({
    queryKey: ['orderExports', { sortProp: this.sortProp(), sortDir: this.sortDir() }], // todo add  queryKey -> sort, filters, schema - columns
    queryFn: async ({ pageParam }) => {
      // const requestId = ++this.currentRequestId // unique ID per call
      // todo. disable for now - querySelectorAll gets all inputs from pages, even when they should be destroyed. (looking at you, Products form fields!)
      return await this.orderExportService
        .getOrderExport(
          {
            page: pageParam,
            sort: this.sortProp(),
            direction: this.sortDir(),
          },
          SchemaUtil.exportOrders
        )
        .then(result => {
          // this.saveViewSettings('printOrderExports', this.filters)
          return result
        })
    },
    initialPageParam: 1,
    getNextPageParam: result => {
      return Number(result?.paginator?.current) < Number(result?.paginator?.endPage)
        ? Number(result?.paginator?.current) + 1
        : undefined
    },
  }))

  constructor(
    protected core: CoreService,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {
    super(core)
    effect(() => {
      this.queryOrderExports.data()
    })
    // this.getStorageKey()
  }

  ngOnInit() {
    // this.filters = this.loadViewSettings('printOrderExports') || { ...DEFAULT_FILTERS }
    this.loadSorting('printOrderExports')
    // this.filter() todo
  }

  ngOnDestroy() {
    this.stopRefreshing()
  }

  async createExportOrders(ordersExport) {
    this.loading = true
    try {
      this.startRefreshing('queryOrderExports')
      await this.core.services.orderExport.create(ordersExport, { id: null }).then(() => {
        this.notificationService.success(this.translateService.instant('alert.order-summary.created'))
      })
      // await this.filter(1) todo
      this.queryOrderExports.refetch()
    } catch (err) {
      console.error(err)
    } finally {
      this.loading = false
      // this.reloading = false
    }
  }

  downloadReport(report: any) {
    this.core.services.download.downloadDocumentAndShowInNewWindow(report.url)
  }
}
